import type { RouteRecordRaw } from 'vue-router';

const vrteSystem: RouteRecordRaw = {
  path: '/',
  name: 'vrteSystem',
  component: () => import('layouts/vcleSystem.vue'),
  children: [{ path: '', name: 'vrteSystemHome', component: () => import('pages/vpgeSystem.vue') }],
};

export default vrteSystem;
